import Colors from "../../../../theme/colors";

export default {
  container: {
    borderRadius: "12px",
    minHeight: "270px",
    minWidth: "570px",
    background: "#FFFFFF",
  },
  main: {
    margin: "3rem 0 0.5rem 0",
  },
  heading: {
    color: "#8C8C8C",
    fontSize: 20,
  },
  submitButton: {
    backgroundColor: "#043D90",
    width: "178px",
    height: "40px",
    marginTop: 30,
  },
  cancelButton: {
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.midnightBlue}`,
    color: Colors.midnightBlue,
    marginLeft: "210px",
    marginTop: -66,
    height: "40px",
    width: "178px",
  },
  divider: {
    display: "flex",
    width: "100%",
    paddingTop: "20px",
  },
  title: {
    color: "#8C8C8C",
    fontSize: 20,
    fontWeight: 500,
  },
  input: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "6px 12px",
    fontSize: "16px",
    outline: "none",
  },
};
